/* eslint-disable @typescript-eslint/no-explicit-any */

import { BarChart } from '../../../types/StatTypes'
import ChartSkeleton from '../../skeleton/ChartSkeleton'
import { useEffect, useId, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectUser } from '../../../reducers/users'
import BaseChart from '../../charts/BaseChart'

interface IVisualizationsBasicBarProps {
  chartData: BarChart
  axisTitle?: string
  tooltipTitle?: string
  long?: boolean
  biggerLabels?: boolean
}

const VisualizationsBasicBar = (props: IVisualizationsBasicBarProps) => {
  const { chartData, axisTitle, tooltipTitle, long, biggerLabels } = props
  const [isLoading, setIsLoading] = useState(true)
  const { darkModeEnabled } = useSelector(selectUser)
  const textColor = darkModeEnabled ? '#FFFFFF' : '#1c2024'
  const chartId = useId()

  useEffect(() => {
    if (chartData && chartData.length > 0) {
      setIsLoading(true)
      const timer = setTimeout(() => setIsLoading(false), 300)
      return () => clearTimeout(timer)
    }
  }, [chartData])

  const options: any = {
    chart: {
      type: 'column',
      height: long ? '720px' : '500px',
      backgroundColor: 'transparent',
    },
    title: {
      text: null,
    },
    xAxis: {
      type: 'category',
      labels: {
        autoRotation: [-45, 90],
        style: {
          fontSize: '12px',
          fontFamily: 'Verdana, sans-serif',
          color: textColor,
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: axisTitle,
        style: {
          color: textColor,
        },
      },
      labels: {
        style: {
          color: textColor,
        },
      },
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      pointFormat: `${tooltipTitle}: <b>{point.y}</b>`,
    },
    series: [
      {
        name: 'Population',
        colors: ['#38d9a9', '#339af0', '#7048e8'],
        colorByPoint: true,
        groupPadding: 0,
        data: chartData,
        minPointLength: 5,
        dataLabels: {
          enabled: false,
          rotation: -90,
          color: textColor,
          inside: true,
          verticalAlign: 'top',
          format: '{point.y}',
          y: 10, // Move labels down
          style: {
            fontSize: '13px',
            fontFamily: 'Verdana, sans-serif',
          },
        },
      },
    ],
    credits: {
      enabled: false,
    },
  }

  if (biggerLabels) {
    options.xAxis = {
      type: 'category',
      labels: {
        rotation: [-45],
        y: 50,
        useHTML: true,
        style: {
          fontSize: '12px',
          fontFamily: 'Verdana, sans-serif',
          width: '110px',
          color: textColor,
        },
      },
    }
  }

  return <>{isLoading ? <ChartSkeleton fullWidth={true} /> : <BaseChart options={options} id={chartId} />}</>
}

export default VisualizationsBasicBar
